import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Scrolls to top on route changes.
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
};
